import React, { useEffect, useState } from "react";
import { VscArrowRight } from "react-icons/vsc";
import { useSelector } from "react-redux";
import ApiNew from "./Api";
import PARSE from "html-react-parser";

const api = new ApiNew();

const SSoft_Industries = ({ industries = [] }) => {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [title, setTitle] = useState(null);
  const [listLine, setListLine] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setTitle(section?.widget_contents[0]);
              break;
            }
            case 1: {
              setListLine(section?.widget_contents);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted === 2) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  return (
    <div className="w-full py-[80px] bg-[#FAF8F5]">
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0D4052] text-center mb-4 max-w-[580px] mx-auto">
          {title?.article_language?.title}
        </h1>

        <p className="text-center text-[#0D4052] max-w-3xl mx-auto mb-12 leading-relaxed">
          {PARSE(title?.article_language?.content || "")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {listLine.map((industry) => {
            // Safely extract icon and description
            const iconAsset = industry?.assets?.[0];
            const icon =
              iconAsset?.file_small ||
              iconAsset?.file_medium ||
              "https://bzpublishassets.blob.core.windows.net/media/assets_small/icon_1_HOGVlub.webp";
            const iconDesc = iconAsset?.description || "Industry solution icon";

            const { article_language } = industry;

            // Content handling — ensure PARSE is defined or use fallback
            const content = article_language?.content
              ? PARSE(article_language.content)
              : "No content available";

            return (
              <div
                key={industry.id}
                className="flex flex-col h-full p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                <h2 className="text-xl sm:text-2xl font-semibold text-[#0D4052] mb-3">
                  {article_language?.title}
                </h2>

                <p className="text-[#0D4052] text-base leading-relaxed mb-6 flex-grow">
                  {content}
                </p>

                <div className="flex items-center justify-between">
                  <button
                    className="text-[#E12726] text-[16px] leading-[150%] flex items-center space-x-2"
                    onClick={() => console.log(`Read more: ${industry.title}`)}
                  >
                    <span>Read more</span>
                    <VscArrowRight className="text-[#E12726]" />
                  </button>

                  <img
                    src={icon.trim()} // trim to remove accidental spaces
                    alt={iconDesc}
                    className="w-12 h-12 sm:w-16 sm:h-16 object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SSoft_Industries;
